














































import { mapGetters } from 'vuex';
import ModalBox from '@/views/components/ModalBox.vue'

export default {
  components: {
    ModalBox
  },
  computed: {
    ...mapGetters(['authUser', 'chinaApk']),
  },
  data() {
    return {
      isModalContactOpened: false
    }
  },
  methods: {
    openModalContact() {
      const vm = this as any
      vm.isModalContactOpened = true
    }
  }
}
